import { useCallback } from 'react';
import { useHttp } from '@hooks/use-http';

export const useStationRequest = () => {
  const http = useHttp();

  const getStations = useCallback(
    async (country: string) => {
      return await http.induction.getStations(country);
    },
    [http],
  );

  const getStationDetails = useCallback(
    async (station: string) => {
      return await http.induction.getStationDetails(station);
    },
    [http],
  );

  return {
    getStations,
    getStationDetails,
  };
};
